const cloneValue = value => {
  if (Array.isArray(value)) return value.map(cloneValue);
  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((copy, [key, nestedValue]) => {
      copy[key] = cloneValue(nestedValue);
      return copy;
    }, {});
  }
  return value;
};

export const createAnnotationDraftController = ({ commit, autosaveMs = 3000 }) => {
  let draft = null;
  let timer = null;

  const cancelTimer = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const clear = () => {
    cancelTimer();
    draft = null;
  };

  const open = (blockId, values = {}) => {
    cancelTimer();
    draft = { blockId, values: cloneValue(values) };
    return true;
  };

  const change = (blockId, values) => {
    if (!draft || draft.blockId !== blockId) return false;

    cancelTimer();
    const valuesSnapshot = cloneValue(values);
    draft = { blockId, values: valuesSnapshot };
    timer = setTimeout(() => {
      timer = null;
      if (draft?.blockId === blockId) {
        commit(blockId, cloneValue(valuesSnapshot));
      }
    }, autosaveMs);
    return true;
  };

  const submit = (blockId, values) => {
    if (!draft || draft.blockId !== blockId) return false;

    const valuesSnapshot = cloneValue(values);
    clear();
    commit(blockId, valuesSnapshot);
    return true;
  };

  const close = () => {
    if (!draft) return false;

    const { blockId, values } = draft;
    clear();
    commit(blockId, cloneValue(values));
    return true;
  };

  const discard = () => {
    clear();
  };

  const getDraft = () => (
    draft
      ? { blockId: draft.blockId, values: cloneValue(draft.values) }
      : null
  );

  return {
    open,
    change,
    submit,
    close,
    discard,
    dispose: discard,
    getDraft,
  };
};
